(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-collection-tabs-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHwCollectionTabsCards(root) {
      var panelsWrap = root.querySelector('[data-hw-collection-tabs-panels]');
      if (!panelsWrap) return;

      var cards = root.querySelectorAll('[data-carousel-card]');
      var panels = panelsWrap.querySelectorAll('[data-collection-panel]');

      function activate(handle) {
        cards.forEach(function (card) {
          var isMatch = card.getAttribute('data-collection-handle') === handle;
          card.classList.toggle('is-active-tab', isMatch);
          card.setAttribute('aria-selected', isMatch ? 'true' : 'false');
          card.setAttribute('tabindex', isMatch ? '0' : '-1');
        });
        panels.forEach(function (panel) {
          var isMatch = panel.getAttribute('data-collection-panel') === handle;
          panel.classList.toggle('is-active', isMatch);
          if (isMatch) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      // Tab pattern (.cursor/rules/tab-accessibility.mdc): the card track is
      // the tablist; arrows / Home / End move focus, Enter / Space select.
      var cardList = [].slice.call(cards);
      if (cardList[0] && cardList[0].parentElement) {
        cardList[0].parentElement.setAttribute('role', 'tablist');
        cardList[0].parentElement.setAttribute('aria-label', root.dataset.tablistLabel || '');
      }

      cardList.forEach(function (card, index) {
        card.addEventListener('keydown', function (e) {
          var target = null;
          if (e.key === 'ArrowRight') target = cardList[(index + 1) % cardList.length];
          else if (e.key === 'ArrowLeft') target = cardList[(index - 1 + cardList.length) % cardList.length];
          else if (e.key === 'Home') target = cardList[0];
          else if (e.key === 'End') target = cardList[cardList.length - 1];
          else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            card.click();
            return;
          }
          if (!target) return;
          e.preventDefault();
          cardList.forEach(function (c) {
            c.setAttribute('tabindex', c === target ? '0' : '-1');
          });
          target.focus();
          target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      });

      cards.forEach(function (card) {
        var handle = card.getAttribute('data-collection-handle');
        if (!handle) return;
        card.setAttribute('role', 'tab');
        card.addEventListener('click', function (e) {
          // Cards render via hw-card, which may include its own link to the
          // collection page. Intercept navigation - switching tabs must not
          // trigger a page load or URL change.
          var link = e.target.closest('a');
          if (link) e.preventDefault();
          activate(handle);

          // Lets the other script block load this tab's grid - see the
          // 'hw:collection-tab-activated' listener above.
          root.dispatchEvent(new CustomEvent('hw:collection-tab-activated', { detail: { handle: handle } }));

          // Pointer clicks only (detail > 0). From the keyboard the focused tab
          // would scroll out of view (WCAG 2.4.11); its panel is the next Tab stop.
          if (e.detail > 0) scrollToPanel(handle);
        });
      });

      // On a tall screen the grid starts below the fold, so a tab switch looked
      // like nothing happened. Bring the panel's top (filter bar + first row)
      // up to just under the sticky header and any sticky subnav below it.
      var PANEL_SCROLL_GAP = 16;
      function scrollToPanel(handle) {
        var panel = panelsWrap.querySelector('[data-collection-panel="' + handle + '"]');
        if (!panel) return;

        var bodyStyle = getComputedStyle(document.body);
        var headerBottom =
          (parseFloat(bodyStyle.getPropertyValue('--hw-sticky-offset')) || 0) +
          (parseFloat(bodyStyle.getPropertyValue('--header-height')) || 0) +
          (parseFloat(bodyStyle.getPropertyValue('--hw-collection-subnav-height')) || 0);
        var delta = panel.getBoundingClientRect().top - headerBottom - PANEL_SCROLL_GAP;
        if (Math.abs(delta) < 2) return;

        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollBy({ top: delta, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      // The page's own collection's tab is active by default, otherwise the
      // first tab (merchant's first block, not necessarily "All").
      // hydratePanels (the inline <script> above, which runs before this
      // bundled script) already shows that same panel un-hidden; this just
      // brings the card's own selected styling into sync with it.
      var initialCard = root.querySelector('[data-carousel-card][data-tab-initial]') || cards[0];
      var initialHandle = initialCard && initialCard.getAttribute('data-collection-handle');
      if (initialHandle) {
        activate(initialHandle);
        // Same prefetch signal a card click sends - the page loads with
        // this tab already active, so it needs the same head start on
        // fetching its real filter list as a clicked-into tab gets.
        root.dispatchEvent(new CustomEvent('hw:collection-tab-activated', { detail: { handle: initialHandle } }));
      }
    }

    document.querySelectorAll('.hw-collection-tabs-cards').forEach(initHwCollectionTabsCards);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
